import './MasterLayout.scss';
import Header from 'app/shared/Header';
import AppLoader from 'app/shared/AppLoader';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';

function MasterLayout() {
	const dashboardLoaded = useSelector((state) => state.dashboardLoaded);
	// console.log(dashboardLoaded, '>>>');

	return (
		<div className="MasterLayout">
			<div className="MasterBody">
				<Header />

				{/* {dashboardLoaded ? ( */}
				<div className="Content">
					<Outlet />
				</div>
				{/* // ) : (
				// 	<div className="AppLoaderCon">
				// 		<AppLoader />
				// 	</div>
				// )} */}
			</div>
		</div>
	);
}

export default MasterLayout;
